import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Spinner from '../../../components/spinner/spinner';
import useFetchCities from './hooks/useFetchCities';
import AddCity from './addcity.component';

const CustomNoRowOverlay = () => {
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'text.secondary',
            }}
        >
            No cities were added yet
        </Box>
    );
};

const CitiesList = () => {
    const { cities, loading, error } = useFetchCities();

    const columns = [
        {   field: 'id',
            headerName: 'Sl. No.',
            width: 90,
            renderCell: (params) => {
                return params.api.getRowIndexRelativeToVisibleRows(params.id) + 1; // +1 to make it 1-based index
            },
        },
        {
          field: 'city',
          headerName: 'City',
          flex: 1
        },
        // {
        //   field: 'location',
        //   headerName: 'Location',
        //   flex: 1
        // },
        // {
        //   field: 'openingtime',
        //   headerName: 'Opening Time',
        //   flex: 1,
        //   valueGetter: (value) => `${formatTime(value)}`,
        // //   type: 'number',
        // },
        // {
        //   field: 'closingtime',
        //   headerName: 'Closing Time',
        //   flex: 1,
        //   valueGetter: (value) => `${formatTime(value)}`,
        // //   type: 'number',
        // },
        // {
        //   field: 'fullName',
        //   headerName: 'Full name',
        //   description: 'This column has a value getter and is not sortable.',
        //   sortable: false,
        //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
        // },
    ];

    if (loading) {
        return <div className='centerContent'><Spinner /></div>;
    }

    if (error) {
        return <div className='centerContent'>Error while fetching Cities.</div>;
    }

    return (
        <DataGrid
            rows={cities}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            // checkboxSelection
            disableSelectionOnClick
            // experimentalFeatures={{ newEditingApi: true }}
            slots={{
                noRowsOverlay: CustomNoRowOverlay
            }}
        />
    );
};

const Servicecities = () => {
    return (
        <div className='admin-area-2 test-centers-admin-page'>
            <Typography variant='h5'>Serviceable Cities</Typography>
            <AddCity />
            <div className='page-content'>
                <Paper>
                    <CitiesList />
                </Paper>
            </div>
        </div>
    );
};

export default Servicecities;